import{addDomEvent as o}from"./add-dom-event.mjs.js";import{addPointerInfo as m}from"./event-info.mjs.js";function r(r,t,e,n){return o(r,t,m(e),n)}export{r as addPointerEvent};
